import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, closeModalWithUpdate } from "../../../features/modal/ModalSlice";
import { Box, Chip, InputAdornment, TextField } from "@mui/material";
import CustomButton from "../../Button/CustomButton";
import apiClient from "../../../services/apiClient";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const AddMember = () => {
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.userInfo?.user);

  const handleKeyDown = (event) => {
    if (
      (event.key === " " || event.key === "Enter" || event.key === ",") &&
      inputValue.trim() !== ""
    ) {
      event.preventDefault();
      setEmails([...emails, inputValue.trim()]);
      setInputValue("");
    }
  };

  const handleDelete = (emailToDelete) => () => {
    setEmails(emails.filter((email) => email !== emailToDelete));
  };

  const handleInvitePage = async () => {
    // incase of one email
    let extraEmail = inputValue.trim();
    if (inputValue.trim() !== "") {
      setEmails((prev) => [...prev, inputValue.trim()]);

      setInputValue("");
    }

    // validation for emails
    if (emails.length === 0 && inputValue.trim() === "") {
      setError("Please enter at least one email.");
      return;
    }

    // console.log(emails);

    setLoading(true);
    try {
      await apiClient.post("/invite", {
        invited_by: userInfo?.id,
        emails: extraEmail ? [...emails, extraEmail] : emails,
        company_id: userInfo?.company_id,
        invite_status: "Pending",
        stage_no: "1",
      });

      toast.success("Invite Sent!");
      dispatch(
        closeModalWithUpdate({
          isUpdated: {
            isUpdatedIn: "NEW_MEMBER",
            data: null,
          },
        })
      );
      navigate("/invites");
    } catch (error) {
      if (error.response && error.response.data) {
        const { already_invited_emails, message } = error.response.data;
        let errorMessage = message || "Try again";
        if (already_invited_emails && already_invited_emails.length > 0) {
          errorMessage += `: ${already_invited_emails.join(", ")}`;
        }
        setError(errorMessage);
      } else {
        setError("Try again");
      }
      console.log(error);
      toast.error("Oops! Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  return (
    <div className={"rightModal taskModal"}>
      <div className="modal-header p-3">
        <h4 className="m-0">Add Member</h4>
        <button className="btnClose ms-auto" onClick={handleClosePopup}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Box>
          <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "10px" }}>
            {emails.map((email, index) => (
              <Chip
                key={index}
                label={email}
                onDelete={handleDelete(email)}
                style={{ margin: "5px" }}
              />
            ))}
          </div>
          <TextField
            label="Enter emails"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            variant="outlined"
            fullWidth
            multiline
            rows={2}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            error={!!error}
            helperText={error ? error : "You can enter multiple emails with spaces"}
          />
        </Box>

        <div className="d-flex justify-content-end gap-3 my-4">
          <CustomButton
            type="submit"
            variant="contained"
            color="secondary"
            onClick={handleClosePopup}
          >
            Cancel
          </CustomButton>
          <CustomButton
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleInvitePage}
            loading={loading}
          >
            Submit
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default AddMember;
